import { useGraphQLQuery } from '@betterment/js-runtime';

import {
  EmployersQueryResult,
  FourOhOneKContributionsAllTimeQueryResult,
  FourOhOneKContributionsCurrentYearQueryResult,
} from './data';
import { EmployersDocument } from './graphql/query.employers.generated';
import { FourOhOneKContributionsAllTimeDocument } from './graphql/query.fourOhOneKContributionsAllTime.generated';
import { FourOhOneKContributionsCurrentYearDocument } from './graphql/query.fourOhOneKContributionsCurrentYear.generated';

export const useEmployerFourOhOneKContributionsCurrentYearQuery = (): EmployersQueryResult => {
  const { data } = useGraphQLQuery(EmployersDocument, { throwOnError: true });

  const isLoading = !data;

  return {
    isLoading,
    employers: data?.employers,
  };
};

export const useFourOhOneKContributionsAllTimeQuery = (): FourOhOneKContributionsAllTimeQueryResult => {
  const { data } = useGraphQLQuery(FourOhOneKContributionsAllTimeDocument, { throwOnError: true });

  const isLoading = !data;

  return {
    isLoading,
    fourOhOneKContributionsAllTime: data?.fourOhOneKContributions?.allTime,
  };
};

export const useFourOhOneKContributionsCurrentYearQuery = (): FourOhOneKContributionsCurrentYearQueryResult => {
  const { data } = useGraphQLQuery(FourOhOneKContributionsCurrentYearDocument, { throwOnError: true });

  const isLoading = !data;

  return {
    isLoading,
    fourOhOneKContributionCurrentYear: data?.fourOhOneKContributions?.thisYear,
    employers: data?.employers,
  };
};
